import MegaMenu from './js/template-parts/components/megamenu'

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.megamenu = new MegaMenu()
  })
} else {
  window.megamenu = new MegaMenu()
}
